/* eslint-disable */
import { Button, withStyles } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import BusinessIcon from '@material-ui/icons/Business';
import FolderIcon from '@material-ui/icons/Folder';
import cn from 'classnames';
import find from 'lodash/find';
import get from 'lodash/get';
import React, { useContext, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import AccountsContext from '../../Contexts/Accounts/Accounts.context';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_PROJECT_FILTER_MODAL_APPLY_CLICK, UI_PROJECT_FILTER_MODAL_CLOSE, UI_PROJECT_FILTER_MODAL_OPEN } from '../../State/Store/UI/UI.types';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Modal from '../Modal/Modal.component';
import OrderStatus from '../OrderStatus/OrderStatus.component';
import OrderTime from '../OrderTime/OrderTime.component';
import OrderTitle from '../OrderTitle/OrderTitle.component';
import OrderSummaryPropTypes from './OrderSummary.component.props';
import orderSummaryStyles from './OrderSummary.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * OrderSummaryComponent
 * @param {Object} props props
 * @returns {React.Component} component
 */
export const OrderSummaryComponent = (props) => {
  const { summary, classes, width, qaDayAttribute } = props;
  const { startTime, title, subTitle, status, customerCode, projectName } = summary;
  const accounts = useContext(AccountsContext) || [];
  const account = find(accounts, (a) => a.CustomerCode.trim() === customerCode) || {};
  const smallScreen = isWidthDown(`md`, width);
  const [projectFilterModalVisible, setProjectFilterModalVisible] = useState(false);

  /**
   * Shows confirmation modal
   * @param {Object} e event
   * @returns {void} void
   * @memberof OrderSummaryComponent
   */
  const showProjectFilterModal = (e) => {
    const { actions } = props;
    actions.uiTriggered({
      payload: {
        data: {
          name: `projectFilterModalOpen`,
        },
      },
      type: UI_PROJECT_FILTER_MODAL_OPEN,
    });
    e.stopPropagation();
    setProjectFilterModalVisible(true);
    return;
  };

  /**
   * Hides confirmation modal
   * @param {Object} e event
   * @returns {void} void
   * @memberof OrderSummaryComponent
   */
  const closeProjectFilterModal = (e) => {
    const { actions } = props;
    actions.uiTriggered({
      payload: {
        data: {
          name: `projectFilterModalClose`,
        },
      },
      type: UI_PROJECT_FILTER_MODAL_CLOSE,
    });
    e.stopPropagation();
    setProjectFilterModalVisible(false);
    return;
  };

  /**
   * Applies clicked filter and hides modal
   * @param {Object} e event
   * @returns {void} void
   * @memberof OrderSummaryComponent
   */
  const applyFilter = (e) => {
    const { actions } = props;
    actions.uiTriggered({
      payload: {
        data: {
          name: `projectFilterModalApplyClick`,
        },
      },
      type: UI_PROJECT_FILTER_MODAL_APPLY_CLICK,
    });
    e.stopPropagation();
    setProjectFilterModalVisible(false);
    actions.filtersSelectProject(projectName);
    return;
  };

  return (
    <React.Fragment>
      {/* Wrapping span is required so clicking anywhere on modal won't propagate to parent component that for some reason has listener set up to redirect to order page. */}
      <span onClick={(e) => e.stopPropagation()}>
        <Modal
          content={
            <Chip className={cn(classes.colorZambezi600)} icon={<FolderIcon className={classes.colorZambezi600} />} label={projectName} variant="outlined" />
          }
          footer={
            <Grid className={classes.textAlignRight} container justify="flex-end" spacing={2}>
              <Grid className={classes.flexGrow1} item>
                <Button className={classes.button} color="primary" onClick={applyFilter} variant="contained">
                  Apply
                </Button>
              </Grid>
              <Grid item>
                <Button className={classes.button} color="primary" onClick={closeProjectFilterModal} variant="outlined">
                  CANCEL
                </Button>
              </Grid>
            </Grid>
          }
          paperClasses={classes.paperClasses}
          maxWidth="sm"
          preventFullScreen
          onClose={closeProjectFilterModal}
          open={!!projectFilterModalVisible}
          rightHeading={null}
          title={
            <Grid container>
              <Grid item xs={12}>
                Apply project filter?
              </Grid>
            </Grid>
          }
        />
      </span>

      {smallScreen ? (
        <Grid alignItems="flex-start" container direction="row" justify="flex-start" className={classes.container}>
          <Grid item xs={12}>
            <Grid item className={cn(classes.flexGrow1)}>
              <OrderTitle subTitle={subTitle} title={title} startTime={startTime} qaDayAttribute={qaDayAttribute} />
            </Grid>
          </Grid>
          <Grid container>
            <Grid alignItems="center" className={classes.chips} container direction="row" justify="flex-start" spacing={1}>
              <Grid item>
                <OrderStatus status={status} />
              </Grid>
              {projectName && (
                <Grid item data-mf-replace-inner={MFSDR}>
                  <Chip
                    className={cn(classes.colorZambezi600, classes.chipCursorClickable)}
                    icon={<FolderIcon className={classes.colorZambezi600} />}
                    label={projectName}
                    variant="outlined"
                    onClick={showProjectFilterModal}
                  />
                </Grid>
              )}
              <Grid item data-mf-replace-inner={MFSDR}>
                <Chip
                  className={cn(classes.colorZambezi600, classes.chipCursor, classes.lastChip)}
                  icon={<BusinessIcon className={classes.colorZambezi600} />}
                  label={get(account, `AccountName`, customerCode)}
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <div className={classes.shade}>&nbsp;</div>
          </Grid>
        </Grid>
      ) : (
        <Grid alignItems="flex-start" container direction="row" justify="flex-start" className={classes.container}>
          <Grid item xs={2}>
            <OrderTime date={startTime} />
          </Grid>
          <Grid item xs={10}>
            <OrderTitle subTitle={subTitle} title={title} qaDayAttribute={qaDayAttribute} />
            <Grid alignItems="center" className={classes.chips} container direction="row" justify="flex-start" spacing={1}>
              <Grid item>
                <OrderStatus status={status} />
              </Grid>
              <Grid item data-mf-replace-inner={MFSDR}>
                {projectName && (
                  <Chip
                    className={cn(classes.colorZambezi600, classes.chipCursor)}
                    icon={<FolderIcon className={classes.colorZambezi600} />}
                    label={projectName}
                    variant="outlined"
                    onClick={showProjectFilterModal}
                  />
                )}
              </Grid>
              <Grid item data-mf-replace-inner={MFSDR}>
                <Chip
                  className={cn(classes.colorZambezi600, classes.chipCursor)}
                  icon={<BusinessIcon className={classes.colorZambezi600} />}
                  label={get(account, `AccountName`, customerCode)}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
};

OrderSummaryComponent.propTypes = OrderSummaryPropTypes;
OrderSummaryComponent.displayName = `OrderSummary`;

/** @type {React.ComponentClass<AuthExpiryComponentProps>} */
const OrderSummary = compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(orderSummaryStyles), { withTheme: true }),
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...filtersActionCreators,
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderSummaryComponent);

export default OrderSummary;
